import cookie from '../../common/cookie';
import url from '../../common/url';
import { loginCookie } from '../login/common';
var qqAppid = '101477677';
var wxAppid = 'wx9119237228a902da';
var testHost = 'test3.guyu.qq.com';
var proHost = 'm.gamer.qq.com';
var miloSelfConfig = {
  isMiloWayCookies: true,
  appName: 'gamer'
};

var loadJsApi = function loadJsApi() {
  return new Promise(function (resolve) {
    resolve(null);
  });
};

var Host = '';

if (url.request('isTestEnv') === 'true') {
  Host = testHost;
} else {
  Host = proHost;
}

var loginByQQAndWX = function loginByQQAndWX() {
  var currentLocation = location.href;
  location.href = "https://".concat(Host, "/v2/gamerapp/forcelogin?from=app&url=").concat(encodeURIComponent(currentLocation));
};

var loginByWX = function loginByWX() {
  // 先游不支持指定渠道，拉起联合登录兜底
  loginByQQAndWX();
};

var loginByQQ = function loginByQQ() {
  // 先游不支持指定渠道，拉起联合登录兜底
  loginByQQAndWX();
};

var setAppCookie = function setAppCookie() {
  console.log('beforeSetCookie');
  return new Promise(function (resolve) {
    var logintype = cookie.get('acctype');
    var mobileqopenid = cookie.get('openid');
    var mobileqtoken = cookie.get('access_token');
    var wopenid = cookie.get('openid');
    var waccesstoken = cookie.get('access_token');

    if (logintype === 'qc' && mobileqopenid && mobileqtoken) {
      window.iUseQQConnect = 1;
      loginCookie.setLocal({
        acctype: 'qc',
        appid: qqAppid,
        openid: mobileqopenid,
        access_token: mobileqtoken
      }, 7200);
    } else if (logintype === 'wx' && wopenid && waccesstoken) {
      loginCookie.setQQ({
        acctype: 'wx',
        appid: wxAppid,
        openid: wopenid,
        access_token: waccesstoken
      }, 7200);
    }

    resolve();
  });
};

var getLoginType = function getLoginType() {
  return new Promise(function (resolve) {
    var currentAcctype = cookie.get('acctype');
    console.log('当前登录方式', currentAcctype);

    if (currentAcctype === 'wx') {
      resolve('wx');
    } else if (currentAcctype === 'qc') {
      resolve('qc');
    } else {
      resolve(null);
    }
  });
};

var logout = function logout() {
  loginCookie.clearLocal();
  loginCookie.clearQQ();
};

var gamer = {
  loadJsApi: loadJsApi,
  loginByWX: loginByWX,
  loginByQQ: loginByQQ,
  loginByQQAndWX: loginByQQAndWX,
  setAppCookie: setAppCookie,
  getLoginType: getLoginType,
  logout: logout,
  miloSelfConfig: miloSelfConfig
};
export default gamer;